import React from 'react';

function EmptySpan(props) {
    return (
        <div style={{width: props.width, height: '1px', display: "inline-block" }}/>
    )
}

export default EmptySpan;